<template>
  <div>
    <el-dialog
      :title="$t('certificate_details')"
      :visible.sync="dialogVisible"
      custom-class="editInfo-dialog"
      :show-close="false"
      top="30vh"
      :before-close="editClickCanc"
    >
      <p class="certificate-tips">
        {{ $t("certificate_tips") }}
      </p>
      <el-form :model="dialogInfo" ref="editInfo">
        <el-form-item :label="$t('firstName')" prop="given_name" :rules="rule.given_name">
          <el-input
            v-model="dialogInfo.given_name"
            autocomplete="off"
            clearable
            :class="language === 'zh' ? 'chinaType' : ''"
            :maxlength="200"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lastName')" prop="family_name" :rules="rule.family_name">
          <el-input
            v-model="dialogInfo.family_name"
            autocomplete="off"
            class="first-inp"
            ref="firstInp"
            clearable
            :class="language === 'zh' ? 'chinaType' : ''"
            :maxlength="200"
          >
          </el-input>
        </el-form-item>

        <div class="select-sex">
          <div class="sex-title">{{ $t("gender") }}</div>
          <div
            v-for="(item, index) in genderArr"
            :key="index"
            class="sex-box"
            :class="activeGenderIndex === index ? 'active' : ''"
            @click="chooseGender(index)"
          >
            <SvgIcon type="male" v-show="index === 0" class="sex-icon" style="width: 16px; height: 16px" />
            <SvgIcon type="female" v-show="index === 1" class="sex-icon" style="width: 16px; height: 16px" />
            <div class="text">{{ item }}</div>
          </div>
        </div>
        <el-form-item :label="$t('country')" prop="country_id" :rules="rule.country_id">
          <el-select
            v-model="dialogInfo.country_id"
            filterable
            :placeholder="$t('batch_select')"
            v-if="countryList && countryList.length > 0"
          >
            <el-option v-for="item in countryList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <p class="send-email">
          {{ $t("email_to") }} <span>{{ email }}</span>
        </p>
        <el-form-item class="dialog-footer">
          <el-button @click="editClickCanc" class="button canc-button">{{ $t("cancel") }}</el-button>
          <el-button type="primary" class="button save-button" @click="editClickSave">{{
            $t("button_common_ok")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { apiRequest } from "@/serves/http";
import ApiPath from "@/serves/path";
import { mapState } from "vuex";
export default {
  components: {
    SvgIcon,
  },
  props: {
    editCertificateDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogInfo: {
        given_name: "",
        family_name: "",
        gender: "",
        country_id: "",
      },
      genderArr: [this.$t("male"), this.$t("female"), this.$t("non_disclosure")],
      activeGenderIndex: null,
      genderMapIndex: {
        male: 0,
        female: 1,
        other: 2,
      },
      language: "zh",
      rule: {
        family_name: [{ required: true, message: this.$t("enter_family_name"), trigger: "blur" }],
        given_name: [{ required: true, message: this.$t("enter_given_name"), trigger: "blur" }],
        country_id: [{ required: true, message: this.$t("select_country"), trigger: "blur" }],
      },
      countryList: [],
    };
  },
  created() {
    this.getCountryList(0);
    this.language = localStorage.getItem("language");
    console.log(this.given_name, "this.given_name");
    this.dialogInfo = {
      given_name: this.given_name,
      family_name: this.family_name,
      gender: this.gender,
      country_id: this.country_id,
    };
    this.activeGenderIndex = this.genderMapIndex[this.gender];
  },
  watch: {
    editCertificateDialogVisible: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("user", ["given_name", "family_name", "gender", "email", "country_id"]),
  },
  methods: {
    // 点击取消按钮
    editClickCanc() {
      this.$emit("close");
      this.$refs.editInfo.resetFields();
      console.log(this.dialogInfo);
    },
    //点击保存按钮
    editClickSave() {
      if (this.activeGenderIndex === 0) {
        this.dialogInfo.gender = "male";
      } else if (this.activeGenderIndex === 1) {
        this.dialogInfo.gender = "female";
      } else {
        this.dialogInfo.gender = "other";
      }

      this.$refs.editInfo.validate((valid) => {
        if (valid) {
          const params = {
            ...this.dialogInfo,
          };
          this.$emit("save", params);
          console.log(params);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 选择性别
    chooseGender(index) {
      this.activeGenderIndex = index;
    },
    // 获取国家列表
    getCountryList() {
      apiRequest.get(ApiPath.get_country_list).then((res) => {
        this.countryList = res?.data?.country_list || [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .editInfo-dialog {
  width: 422px;
  height: 560px;
  border-radius: 12px;
  .certificate-tips {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #b5b5be;
    background: #fafafb;
    padding: 10px 32px;
    word-break: break-word;
  }
  .el-dialog__body {
    padding-bottom: 4px;
    padding: 0 !important;
    .el-form {
      padding: 20px;
      .el-form-item__label {
        margin-left: 9px;
        color: #b5b5be;
        display: flex;
        flex-direction: row-reverse;
        width: auto;
        font-family: "Inter";
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
      }
      .el-form-item {
        display: flex;
        &__content {
          flex: 1;
          .el-select {
            width: 100%;
          }
        }
      }
    }
  }
  .el-dialog__title {
    font-weight: 600;
  }
  .el-input--suffix {
    .el-input__inner {
      border-radius: 6px;
      background: #fafafb;
      border: none;
      font-size: 17px;
      &:focus {
        border: 1px solid #515571;
        background: #fff;
      }
    }
  }

  .dialog-footer {
    margin-top: 82px;
    display: flex;
    justify-content: flex-end;
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
      .button {
        width: 171px;
        height: 44px;
        border-radius: 8px;
        font-family: "Inter";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        &.canc-button {
          background: #efeff1;
          border: none;
          &:hover {
            color: #606266;
          }
        }
        &.save-button {
          background: #faae56;
          color: #fff;
          border: none;
        }
      }
    }
  }
  .input-title {
    padding-left: 20px;
  }
  .select-sex {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    color: #b5b5be;
    .sex-title {
      line-height: 44px;
      margin-left: 9px;
      &::after {
        content: "*";
        color: #fc5a5a;
      }
    }
    .sex-box {
      width: 86px;
      height: 44px;
      border-radius: 8px;
      line-height: 20px;
      background: #fafafb;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      &:not(:last-child) .text {
        margin-left: 9px;
      }
      &.active {
        border: 3px solid #faae56;
        background: #ffffff;
      }
    }
  }
  .send-email {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #2c2f46;
    margin-top: 5px;
    margin-left: 10px;
    span {
      font-weight: bold;
    }
  }
}
</style>
